import { Col, Row, TextInput } from 'ui';

export type JoinedCommunitiesListFiltersFormValues = {
  search?: string;
};

const JoinedCommunitiesListFilters = () => (
  <Row>
    <Col span={24}>
      <TextInput hasSearch item={{ label: 'Search', name: 'search' }} />
    </Col>
  </Row>
);

export default JoinedCommunitiesListFilters;
